import React from 'react';
import { Clock, Star, ArrowRight } from 'lucide-react';

interface TrialBannerProps {
  onStartTrial: () => void;
  className?: string;
}

const TrialBanner: React.FC<TrialBannerProps> = ({ onStartTrial, className = '' }) => {
  return (
    <div className={`bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 rounded-xl p-6 ${className}`}>
      <div className="text-center">
        <div className="flex justify-center mb-3">
          <div className="w-12 h-12 bg-black text-white rounded-xl flex items-center justify-center">
            <Clock className="w-6 h-6" />
          </div>
        </div>
        
        <h3 className="text-xl font-bold text-black mb-2">
          Try Starter Plus ($9.99/month) or Pro ($39.99/month)
        </h3>
        
        <p className="text-gray-600 mb-4">
          Experience unlimited videos, no watermarks, and priority processing
        </p>
        
        <div className="flex items-center justify-center space-x-4 mb-4 text-sm text-gray-600">
          <div className="flex items-center">
            <Star className="w-4 h-4 mr-1" />
            <span>No watermarks</span>
          </div>
          <div className="flex items-center">
            <Star className="w-4 h-4 mr-1" />
            <span>Cancel anytime</span>
          </div>
        </div>
        
        <button
          onClick={onStartTrial}
          className="bg-red-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-red-700 transition-colors flex items-center mx-auto"
        >
          Choose Your Plan
          <ArrowRight className="w-5 h-5 ml-2" />
        </button>
      </div>
    </div>
  );
};

export default TrialBanner; 